const PRIVACY_POLICY_LINK = "https://www.integratedmusicrights.com/privacy-policy";
const TERMS_OF_USE_LINK = "https://www.integratedmusicrights.com/terms-of-use ";
const COOKIE_POLICY_LINK = "https://davidccook.org/cookie-policy";

export { PRIVACY_POLICY_LINK, TERMS_OF_USE_LINK, COOKIE_POLICY_LINK };
